import { Component, OnInit, Input } from '@angular/core';
import { Partner, ImageDescription, PartnerButton } from '@fitscovery/partner/data-access';
import { UtilCustomButtonAlignment } from '../../../../shared/util';

@Component({
  selector: 'fitscovery-ui-groove-section-odd',
  templateUrl: './ui-groove-section-odd.component.html',
  styleUrls: ['./ui-groove-section-odd.component.scss', '../partner-homepage-groove-style.scss']
})
export class UiGrooveSectionOddComponent implements OnInit {
  @Input() partner: Partner;
  @Input() imageDescription: ImageDescription;

  constructor() { }

  ngOnInit(): void {
  }

  setButtonAlignmentClass(button: PartnerButton): string {
    return UtilCustomButtonAlignment.setButtonAlignment(button)!;
  }

}
